import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './TableList.css';
import AdminEventFormModal from './AdminEventFormModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';


export default function AdminClubEvents() {
    const { clubId } = useParams();
    const navigate = useNavigate();
    const token = localStorage.getItem('adminToken');

    const [clubName, setClubName] = useState('');
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [showModal, setShowModal] = useState(false);
    const [editingEvent, setEditingEvent] = useState(null);

    const handleDelete = async (eventId) => {
        if (!window.confirm('Sigur vrei să ștergi acest eveniment?')) return;

        try {
            const res = await fetch(
                `https://www.fro.ro/api/admins/delete-event.php?id=${eventId}`,
                {
                    method: 'DELETE',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const data = await res.json();

            if (data.success) {
                alert('Eveniment șters.');
                fetchEvents();
            } else {
                alert(data.message || 'Eroare la ștergere');
            }
        } catch (err) {
            alert('Eroare de conexiune');
        }
    };


    /* ================== FETCH CLUB + EVENTS ================== */
    const fetchEvents = async () => {
        setLoading(true);
        setError(null);

        try {
            // 🔹 Nume club
            const clubRes = await fetch(
                `https://www.fro.ro/api/admins/get-club.php?id=${clubId}`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            const clubData = await clubRes.json();
            setClubName(clubData.success ? clubData.club.name : `Club #${clubId}`);

            // 🔹 Evenimente club
            const res = await fetch(
                `https://www.fro.ro/api/admins/club-events.php?club_id=${clubId}`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            const data = await res.json();

            if (data.success) {
                setEvents(data.data || []);
            } else {
                setError(data.message || 'Eroare la încărcarea evenimentelor');
            }
        } catch {
            setError('Eroare de conexiune');
        } finally {
            setLoading(false);
        }
    };

    /* ================== INIT ================== */
    useEffect(() => {
        fetchEvents();
    }, [clubId]);

    if (loading) return <p>Se încarcă evenimentele...</p>;
    if (error) return <p style={{ color: 'red' }}>{error}</p>;

    return (
        <div className="table-list-container">
            <div className="table-list-header">
                <button className="back-btn" onClick={() => navigate(-1)}>
                    ⬅ Înapoi
                </button>

                <h1>Evenimente – {clubName}</h1>

                <button
                    className="add-circle-btn"
                    onClick={() => {
                        setEditingEvent(null);
                        setShowModal(true);
                    }}
                    aria-label="Adaugă eveniment"
                >
                    <span className="plus-icon">+</span>
                </button>
            </div>

            <table className="table-list">
                <thead>
                    <tr>
                        <th>Nume</th>
                        <th>Perioadă</th>
                        <th>Locație</th>
                        <th>Acțiuni</th>
                    </tr>
                </thead>
                <tbody>
                    {events.length === 0 ? (
                        <tr>
                            <td colSpan={4}>Nu există evenimente.</td>
                        </tr>
                    ) : (
                        events.map(ev => (
                            <tr key={ev.id}>
                                <td>{ev.name}</td>
                                <td>{ev.start_date} – {ev.end_date}</td>
                                <td>{ev.location}</td>
                                <td className="table-list-actions">
                                    <button
                                        className="action-btn edit"
                                        title="Editează"
                                        onClick={() => {
                                            setEditingEvent(ev);
                                            setShowModal(true);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faPen} />
                                    </button>

                                    <button
                                        className="action-btn delete"
                                        title="Șterge"
                                        onClick={() => handleDelete(ev.id)}
                                    >
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </td>

                            </tr>
                        ))
                    )}
                </tbody>
            </table>

            {/* 🔹 MODAL CREATE / EDIT */}
            {showModal && (
                <AdminEventFormModal
                    clubId={clubId}
                    editData={editingEvent}
                    onClose={() => {
                        setShowModal(false);
                        setEditingEvent(null);
                    }}
                    onEventAdded={() => {
                        setShowModal(false);
                        setEditingEvent(null);
                        fetchEvents();
                    }}
                />
            )}
        </div>
    );
}
